export default "__VITE_ASSET__CulvWIbn__"